import RMSvgIcon, {
  RMSvgIconProps,
} from 'components/customComponents/CommonComponents/RMSvgIcon';
import RMModal from 'components/modal/RMModal';
import RMTable from 'components/customComponents/Controls/RMTable';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { IStyle } from 'Styles';
import HeaderBar from './HeaderBar';
import { useFetchAllPuckTypes, useFetchAllPucks } from './hooks';
import { onCellChange, onDelete, preDelete, puckTableColumns } from './utils';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';

export interface PuckProps {
  puckInfo: any[];
  rowExtraInfo: any;
  setPuckInfo: React.Dispatch<React.SetStateAction<any[]>>;
  setInitialPuckInfo: React.Dispatch<React.SetStateAction<any[]>>;
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
  setRowExtraInfo: React.Dispatch<React.SetStateAction<{}>>;
  deletedPucks: any[];
  inUseAlert?: (type: string) => void;
}

export const puckTypeIcon = (title) => {
  return <PuckImage title={title?.split(' ')[0]} />;
};

const puckTypeIconProps: RMSvgIconProps = {
  name: 'Union',
  fill: 'black',
};

const PuckContent = (props: PuckProps) => {
  const {
    puckInfo,
    rowExtraInfo,
    setPuckInfo,
    setInitialPuckInfo,
    setIsDirty,
    setRowExtraInfo,
    deletedPucks,
    inUseAlert,
  } = props;
  const [puckTypes, setPuckTypes] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([0]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const onAdd = () => {
    const newPuckInfo = [...puckInfo];
    const newPuckItem = {
      index: newPuckInfo.length,
      name: '',
      barcode: '',
      rowIsDirty: true,
      puckType: puckTypes.length ? puckTypes[0].title : '',
      pinCount: 0,
      puckTypeId: puckTypes.length ? puckTypes[0].id : 0,
      enable: true,
      added: true,
    };
    newPuckInfo.push(newPuckItem);
    setPuckInfo(newPuckInfo);
    setSelectedIds([newPuckInfo.length - 1]);
  };

  // eslint-disable-next-line
  const renderTableData = useMemo(() => {
    const tempData = [...puckInfo].map((puck) => {
      return {
        name: (
          <input
            id="puckcontent-input-name"
            type="text"
            style={puck.name === '' ? styles.nameStyling : styles.nameStyling2}
            className="table-input-style"
            onChange={(e) =>
              onCellChange(
                e,
                'Puck',
                puck.index,
                'name',
                puckInfo,
                setPuckInfo,
                setIsDirty,
                null,
                inUseAlert,
              )
            }
            value={puck.name}
            title={puck.name}
          />
        ),
        barcode: (
          <input
            id="puckcontent-input-barcode"
            type="text"
            className="table-input-style"
            onChange={(e) =>
              onCellChange(
                e,
                'Puck',
                puck.index,
                'barcode',
                puckInfo,
                setPuckInfo,
                setIsDirty,
                null,
                inUseAlert,
              )
            }
            value={puck.barcode}
            title={puck.barcode}
          />
        ),
        puckType: (
          <select
            id="puckcontent-selectbox-pucktype"
            className="table-input-style"
            style={{ width: '80%', padding: '0px', margin: '0px' }}
            value={puck.puckType}
            onChange={(e) =>
              onCellChange(
                e,
                'Puck',
                puck.index,
                'puckType',
                puckInfo,
                setPuckInfo,
                setIsDirty,
                puckTypes,
                inUseAlert,
              )
            }
            disabled={false}
          >
            {puckTypes.map((val) => (
              <option key={val.id} value={val.value}>
                {val.title}
              </option>
            ))}
          </select>
        ),
        puckLogo: <PuckImage title={puck.puckType?.split(' ')[0]} />,
        pinCount: puckTypes.find((x) => x.title === puck.puckType)?.pinCount,
        puckTypeId: puckTypes.find((x) => x.title === puck.puckType)?.id,
        enable: (
          <input
            id="puckcontent-input-enable"
            style={styles.checkBox}
            type="checkbox"
            onChange={(e) =>
              onCellChange(
                e,
                'Puck',
                puck.index,
                'enable',
                puckInfo,
                setPuckInfo,
                setIsDirty,
                null,
                inUseAlert,
              )
            }
            checked={puck.enable}
            value={puck.enable}
          />
        ),
      };
    });
    setTableData([...tempData]);
  }, [puckInfo]);

  const onCheckboxSelectionChange = (rowIndices: number[]) => {
    setSelectedIds([...rowIndices]);
  };

  const handleOnRowCLick = (row) => {
    setSelectedIds([row.index]);
  };

  useFetchAllPucks(setPuckInfo, setInitialPuckInfo);
  useFetchAllPuckTypes(setPuckTypes);
  return (
    <div
      id="puckcontent-wrapper"
      className="flex-[2] flex flex-col h-[88vh] overflow-hidden m-1 border border-solid border-black"
    >
      <div id="puckcontent-header">
        <HeaderBar
          title="Puck Definition"
          onAdd={onAdd}
          onDelete={() =>
            onDelete(
              puckInfo,
              selectedIds,
              'Puck',
              setShowDeleteModal,
              setRowExtraInfo,
              setSelectedIds,
              inUseAlert,
            )
          }
          enableEditDelete={puckInfo.length > 0 && selectedIds.length > 0}
        />
      </div>
      <div id="puckcontent-table" className="overflow-auto">
        <RMTable
          columns={puckTableColumns(puckTypes)}
          data={tableData}
          tableClass="rm-table-puck-dewar"
          selectedIds={selectedIds}
          enableMultiSelection={true}
          onCheckboxSelectionChange={onCheckboxSelectionChange}
          rowExtraInfo={rowExtraInfo}
          onRowClicked={handleOnRowCLick}
        />
      </div>
      {puckInfo.length > 0 && selectedIds.length > 0 && (
        <RMModal
          showModal={showDeleteModal}
          setShowModal={setShowDeleteModal}
          onOk={() =>
            preDelete(
              puckInfo,
              setPuckInfo,
              selectedIds,
              setShowDeleteModal,
              setIsDirty,
              deletedPucks,
            )
          }
          body={'Are you sure you want to delete this item?'}
          heading={`Delete Puck`}
          okButtonText={'CONFIRM'}
        />
      )}
    </div>
  );
};
const styles: IStyle = {
  puckContent: {
    border: '1px solid gray',
    flex: 2,
    margin: '5px 5px',
  },
  nameStyling1: {
    border: '2px solid #DB0000',
    borderRadius: '2px',
    outline: 'none',
    textAlign: 'left',
  },
  nameStyling2: {
    textAlign: 'left',
  },
  checkBox: {
    height: '1.4rem',
  },
};
export default PuckContent;

export const PuckImage = (props) => {
  const { title } = props;
  const ref = useRef<HTMLInputElement>();
  const [show, setShow] = useState(false);
  useEffect(() => {
    const handleClickOutside = (event) => {
      const current = ref.current;
      if (current != null && current != undefined) {
        if (!current?.contains(event.target)) {
          setShow(false);
        }
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
  }, [ref]);

  return (
    <div
      id="puckimage-container"
      ref={ref}
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <div id="puckimage-button">
        <RMCustomButton
          iconProps={puckTypeIconProps}
          onClick={() => {
            setShow(!show);
          }}
          isDisabled={false}
        />
      </div>
      {show && (
        <div id="puckimage-panel" className={'puck-image-panel'}>
          <RMSvgIcon name={title} width="150px" height="120px" fill="transparent" />
        </div>
      )}
    </div>
  );
};
